module.exports = __webpack_public_path__ + "img/0S6A9866.046aec87.jpg";